import { render, staticRenderFns } from "./ExperiencesPickerCard.vue?vue&type=template&id=23e971bc&"
import script from "./ExperiencesPickerCard.vue?vue&type=script&lang=ts&"
export * from "./ExperiencesPickerCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports